import type { NextPage, PageProps } from "next";

import { AppFooter } from "scmp-app/components/app-footer";
import { Button as PostiesButton } from "scmp-app/components/posties/button";
import { PostiesSeo } from "scmp-app/components/posties/posties-seo";

import { Button, Container, Content, Description, Home, Title } from "./styles";

const Posties404Page: NextPage<PageProps> = () => (
  <Container>
    <PostiesSeo />
    <Title>404</Title>
    <Description>
      Oops... The page you were looking for appears to have moved or never existed.
    </Description>
    <Content />
    <PostiesButton pathname="/posties" variant="link">
      <Button>
        <Home />
        BACK TO HOMEPAGE
      </Button>
    </PostiesButton>
    <AppFooter variant="posties" />
  </Container>
);

Posties404Page.displayName = "Posties404Page";

const pageProps: PageProps = {
  appBarConfiguration: {
    variant: "posties/generic",
  },
  appInitializerConfiguration: {
    application: "posties",
  },
};

Posties404Page.getInitialProps = () => pageProps;

export default Posties404Page;
